import type { ComponentProps, FC } from "react";
import type { GameThumbData } from "../../GameThumb";
import Img from "../../Img";
import { TypographyH4 } from "../../Typography";
import GameHorizontalPreviewBadges from "./GameHorizontalPreviewBadges";

const THUMB_WIDTH = 140;

type Props = ComponentProps<"div"> & {
  game?: GameThumbData;
  /** Average RTP as a percentage (e.g. 96.5). Rendered as the second badge, after the provider. */
  rtp?: number;
};

const GameHorizontalPreviewCard: FC<Props> = ({ game, rtp, ...props }) => {
  if (!game) return null;

  const alt = game.name ?? "";

  return (
    <div className="md:w-full md:flex gap-x-4" {...props}>
      <div className="relative">
        {game.thumbUrl && (
          <Img
            src={game.thumbUrl}
            alt={alt}
            width={THUMB_WIDTH}
            dpr={2}
            className="w-35 rounded-lg hidden md:block"
          />
        )}
        {game.thumbUrlTab && (
          <Img
            src={game.thumbUrlTab}
            alt={alt}
            width={THUMB_WIDTH}
            dpr={2}
            className="w-35 rounded-lg block md:hidden"
          />
        )}
      </div>
      <div className="flex flex-col gap-y-2 w-full min-w-0 items-start justify-center">
        <TypographyH4 isBold className="w-full truncate text-lg">
          {game.name}
        </TypographyH4>
        <GameHorizontalPreviewBadges game={game} rtp={rtp} />
      </div>
    </div>
  );
};

export { GameHorizontalPreviewCard };
